module.exports = __webpack_public_path__ + "static/img/附件六.23446f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/附件六.jpg
// module id = jTWg
// module chunks = 1